import { render, staticRenderFns } from "./admin_add.vue?vue&type=template&id=2a07d6b4&scoped=true&"
import script from "./admin_add.vue?vue&type=script&lang=js&"
export * from "./admin_add.vue?vue&type=script&lang=js&"
import style0 from "./admin_add.vue?vue&type=style&index=0&id=2a07d6b4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a07d6b4",
  null
  
)

export default component.exports